import GeneralFooter from './GeneralFooter';

export default GeneralFooter;
